import {
  WooCommerceDatetimeWeekdayConfig,
  WooCommerceDatetimeWeekdays
} from '../../core/interfaces/woo-commerce/api/woo-commerce-api.interface';

const WEEKDAY_KEYS = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'] as const;

function isWeekdayEnabled(config?: WooCommerceDatetimeWeekdayConfig): boolean {
  if (!config) {
    return true;
  }

  const { enable } = config;

  if (typeof enable === 'boolean') {
    return enable;
  }

  if (typeof enable === 'number') {
    return enable !== 0;
  }

  if (typeof enable === 'string') {
    const normalized = enable.trim().toLowerCase();
    return normalized !== '0' && normalized !== 'false' && normalized !== 'no';
  }

  return true;
}

function getWeekdayKey(date: Date, timezone?: string): (typeof WEEKDAY_KEYS)[number] {
  const shortWeekday = date
    .toLocaleDateString('en-US', {
      weekday: 'short',
      ...(timezone ? { timeZone: timezone } : {})
    })
    .toLowerCase();

  const key = shortWeekday.slice(0, 3) as (typeof WEEKDAY_KEYS)[number];

  return WEEKDAY_KEYS.includes(key) ? key : 'sun';
}

export function isDateEnabledByWeekdays(
  date: Date,
  weekdays?: WooCommerceDatetimeWeekdays,
  timezone?: string
): boolean {
  if (!weekdays) {
    return true;
  }

  const key = getWeekdayKey(date, timezone);
  return isWeekdayEnabled(weekdays[key]);
}

export function filterDatesByWeekdayAvailability(
  dates: Date[],
  weekdays?: WooCommerceDatetimeWeekdays,
  timezone?: string
): Date[] {
  if (!weekdays) {
    return dates;
  }

  return dates.filter((date) => isDateEnabledByWeekdays(date, weekdays, timezone));
}
